module.exports = "<div id=\"main\">\n  <ng-content></ng-content>\n</div>\n"